  import * as React from 'react';

  import { useState } from "react";
  import Dialog from '@mui/material/Dialog';
  import DialogTitle from '@mui/material/DialogTitle';
  import DialogContent from '@mui/material/DialogContent';
  import StatusContext from "../../contexts/StatusContext";
  import IconButton from '@mui/material/IconButton';
  import CloseIcon from '@mui/icons-material/Close';
  import { PushButton } from '../main/pushbutton/PushButton';
  


  export const DialogLanguages = () => {
    const [hoveredIndex, setHoveredIndex] = useState(-1); // Default to -1 (no hover)
   

/*
    const languages = [
      { short: 'EN', long: 'English' },
      { short: 'DN', long: 'German' },
      { short: 'FR', long: 'French' },
      { short: 'PR', long: 'Portuguese' },
      { short: 'SP', long: 'Spanish' },
      { short: 'SR', long: 'Serbian'},
      ]
*/
    const {
      supportedlanguages,
      changeLanguage,
      showLanguages,
      setShowLanguages,
      setMainLanguage,
      setShortLanguage,
   
  } = React.useContext(StatusContext);


const styles = {
  container: {
    alignItems: 'center', // Center vertically
    textAlign: 'center', 
    color: 'maroon',
 
    padding: '10px',
    marginBottom: '10px',
    width: '100%',
    border:'none',
 
    cursor: 'pointer',
    backgroundColor: (index) => (hoveredIndex === index ? 'lightcoral' : 'lightblue'), // Change color based on hovered index
    transition: 'background-color 0.3s ease', // Optional transition for smooth effect
    },
  title: {
    display: 'flex',
    color: 'rgb(138, 57, 57)',
    fontSize: '26px',
    marginTop:'-25px',
    marginBottom: '-15px',
    justifyContent: 'center',
  },
  
  text: {
  
    color: 'rgb(138, 57, 57)',
    fontSize: '16px',
    fontWeight: '500',
    marginBottom:'15px',
    justifyContent: 'center',
    textAlign:'center',
  },
  savebutton: {
   
    justifyContent: 'center',
  }
 
}

  const onSelectLanguage = (index) => {
    console.log("selected Language:", supportedlanguages[index].long)
    setMainLanguage(supportedlanguages[index].long)
    setShortLanguage(supportedlanguages[index].short)
  
    localStorage.setItem("mainLanguage", supportedlanguages[index].long)
    localStorage.setItem("mainLanguageShort", supportedlanguages[index].short)

    handleClose()
  }

  
  const handleClose = (event, reason) => {
   
  
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      // Handle the backdrop click event here
      return
    }

    setShowLanguages(false)
  
  };


    return (
    
      <React.Fragment>
    
          <Dialog
            open={showLanguages}
          
            PaperProps={{
              component: 'form',
              onSubmit: (event) => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                const formJson = Object.fromEntries(formData.entries());
                const email = formJson.email;
                console.log(email);
                
              },
            }}
          >

          <DialogTitle style = {{fontSize:'14px'}}>
         
          </DialogTitle>


          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
          <CloseIcon />
        </IconButton>

        <br></br>
      
        <DialogTitle style = {styles.title}>
            {"Select your language"}
         
        </DialogTitle>
        
        
          <DialogContent dividers>
          
                <div style={styles.text}>
                <span style = {{fontWeight: '700'}}>{"Note:"}</span>&nbsp;{"The app initerface is translated by AI and may contain some inaccuracies."}
                </div>

                <div>
                {
                  Array.isArray(supportedlanguages) &&
                    supportedlanguages.map((item, index) => (
                      <div key = {index} 
                        style={{ ...styles.container, backgroundColor: styles.container.backgroundColor(index) }}
                        onClick={()=>onSelectLanguage(index)}
                        onMouseEnter={() => setHoveredIndex(index)} // Set hover state to true
                        onMouseLeave={() => setHoveredIndex(-1)} // reset
                      >
                      {supportedlanguages[index].long}
                      <br></br>
                      </div>
                  ))
                }
                <br></br>
                <PushButton onClick={handleClose} label =  {changeLanguage('templates','close')}/>
              
               </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      
    );
    
  }